import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { fadeInOut } from '@x/common/animations';

export type loaderTypes = 'dot-windmill' | 'dot-flashing' | 'circle';
export type loaderTheme = 'light' | 'dark' | 'primary' | 'accent' | 'warn';
export type loaderSize = 'small' | 'default' | 'large';

@Component({
  selector: 'x-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInOut],
  host: { class: 'x-loader' },
})
export class LoaderComponent {
  @Input()
  loader: loaderTypes = 'circle';

  @Input() dots: number = 3;
  get dotsArray() {
    return Array(this.dots).fill(0);
  }

  @Input()
  blurHash?: string | null;

  @Input()
  theme: loaderTheme = 'dark';

  @Input() size: loaderSize = 'default';

  @HostBinding('style.background-color')
  @Input()
  bgcolor: string = 'rgba(255,255,255,0.5)';

  @HostBinding('@fadeInOut')
  fadeInAnimate: string;

  @HostBinding('@.disabled')
  @Input()
  disableAnimation: boolean = false;

  @Input() set opacity(opacity: number) {
    this.bgcolor = `rgba(255,255,255,${opacity})`;
  }
}
